import { render, staticRenderFns } from "./legal-footer.vue?vue&type=template&id=e92c1130&scoped=true"
import script from "./legal-footer.vue?vue&type=script&lang=js"
export * from "./legal-footer.vue?vue&type=script&lang=js"
import style0 from "./legal-footer.vue?vue&type=style&index=0&id=e92c1130&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92c1130",
  null
  
)

export default component.exports